import { ModalCloseButton } from 'dibs-elements/src/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/src/ModalContainer';
import { ModalSpinner } from 'dibs-elements/src/ModalSpinner';
import { lazy, Suspense, type ComponentProps, type FC } from 'react';

const LazyModalContent = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedSellerDetailsModal" */ './PdpSharedSellerDetailsModal'
        )
);

export const PdpSharedSellerDetailsModalLazy: FC<
    ComponentProps<typeof LazyModalContent>
> = props => {
    const { isOpen, onClose, ...rest } = props;

    return isOpen ? (
        <ModalContainer modalSize="medium" modalPosition="top" isOpen={isOpen} onClose={onClose}>
            <ModalCloseButton onClick={onClose} />
            <Suspense fallback={<ModalSpinner isOpen />}>
                <LazyModalContent isOpen={isOpen} onClose={onClose} {...rest} />
            </Suspense>
        </ModalContainer>
    ) : null;
};
